import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Task } from "@common/types/task";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { memo } from "react";
import { KickAvatar } from "@components/avatar/KickAvatar";
import { HStack } from "@design-system/HStack/HStack";
import { NestedTaskRow } from "../../types";

export const CreatedByCell = memo(
    ({ row }: CellContext<ViewTableFeatures, NestedTaskRow, any>) => {
        const task = row.original as Task;

        if (row.original.isGroup || row.original.isNewPlaceholder) {
            return null;
        }

        return (
            <ViewTableCell>
                <HStack gap={8} align="center">
                    {task.createdBy ? (
                        <>
                            <UserAvatar
                                user={task.createdBy}
                                size="sm"
                                aria-hidden
                            />
                            {task.createdBy.name}
                        </>
                    ) : (
                        <>
                            <KickAvatar size="sm" aria-hidden />
                            <span className="text-gray-900">Kick</span>
                        </>
                    )}
                </HStack>
            </ViewTableCell>
        );
    },
);
